import React, { useState } from 'react';
import './login.css';
import { API } from '../API/api';
import { useNavigate } from 'react-router-dom';


const LoginForm = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
const navigate = useNavigate(); 
  const handleSubmit = async(e) => {
    e.preventDefault(); // Prevents page reload
    
     try {
    const response = await API.post('/api/token/', {username,password});
    const { access, refresh } = response.data;

    // Store in localStorage
    localStorage.setItem('accessToken', access);
    localStorage.setItem('refreshToken', refresh);
    navigate('/running');
  } catch (error) {
    console.error('Login API error:', error);
    alert('Failed to login')
  }

  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2 className="login-title">Login to Vote</h2>
        <p className="login-subtext">Secure access to your digital ballot</p>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Username</label>
            <input
              type="text"
              placeholder="snamutebi"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="login-btn">Login</button>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
